// src/components/ProjectCard.jsx
import { Link } from 'react-router-dom';
import Reveal from './Reveal';

/**
 * Card de projeto do portfólio.
 *
 * Usado tanto na página /portfolio (grid completo, `compact={false}`)
 * quanto na vitrine da Home (`compact` = true — some a descrição e as
 * tags de tecnologia, sobra só imagem + categoria + título).
 *
 * Enquanto o projeto não tiver um screenshot real (`project.image`),
 * o card mostra um thumbnail estilizado com as iniciais — no mesmo
 * espírito visual do resto do site (glow + grid sutil). Basta
 * preencher `image` no array de dados para trocar pelo print real.
 */
function ProjectCard({ project, delay = 0, compact = false }) {
  const {
    title,
    category,
    description,
    tags = [],
    url = '#',
    accent = '#0066FF',
    initials = '',
    image,
  } = project;

  const isExternal = url && url !== '#';

  return (
    <Reveal
      as={Link}
      to={url}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noreferrer' : undefined}
      className={`portfolio-card${compact ? ' portfolio-card--compact' : ''}`}
      delay={delay}
      style={{ '--accent': accent }}
    >
      <div className="portfolio-card__thumb">
        {image ? (
          <img src={image} alt={title} loading="lazy" />
        ) : (
          <div className="portfolio-card__mock">
            <div className="portfolio-card__mock-bar">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="portfolio-card__mock-body">
              <span className="portfolio-card__mock-initials">{initials}</span>
            </div>
          </div>
        )}
        <div className="portfolio-card__overlay">
          <span className="portfolio-card__overlay-text">Visitar site ↗</span>
        </div>
      </div>
      <div className="portfolio-card__body">
        <div className="portfolio-card__tag">{category}</div>
        <h3 className="portfolio-card__title">{title}</h3>
        {!compact && description && (
          <p className="portfolio-card__desc">{description}</p>
        )}
        {!compact && tags.length > 0 && (
          <div className="portfolio-card__tags">
            {tags.map((t) => (
              <span key={t} className="portfolio-card__pill">
                {t}
              </span>
            ))}
          </div>
        )}
      </div>
    </Reveal>
  );
}

export default ProjectCard;
